export default function makeLinkStatic(link) {
  if (link.startsWith('http') || link.startsWith('https')) {
    return link;
  }
  return "https://www.surveymonkey.com".concat(link);
}
//# sourceMappingURL=makeLinksStatic.js.map